module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADXSURBVHgBZZBNDoIwEIXbBpqw0HgEjoA3wJ0xSOQGsiTdwAmUEzSGUJYeQTTu8QjeQI5AXLKwduQnNM6infa9+TodnPv5C6lo3+0yeSQNmgTBCMNu0zmtuMsXukjwShlqlTt0RrkmRmVUjwaM9sIXo4HAAgZJZKDSRiIZF35xgHs8xWRe5hJCqq6KHDURIt/mZ8D/VQpP7BT+0h/TUeQb7piGWanG4Dspu7EOy9fcppTCWzb6oBO7s/iH1QSMSnZlwUAzBkHhnha2wmkPRj8+GEQQlqE22y+EsTy5oJowHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Layout/images/menuright.png
// module id = 1505
// module chunks = 0